module.exports = __webpack_public_path__ + "img/product_47.64a4c8b.webp";